import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withKeys as _withKeys, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-58c58400")

_pushScopeId("data-v-58c58400")
const _hoisted_1 = { style: {"flex":"1","overflow-x":"auto"} }
const _hoisted_2 = { style: {"box-sizing":"border-box","color":"#f5f6fa","padding":"20px 0"} }
const _hoisted_3 = { style: {"box-sizing":"border-box","width":"1400px","margin":"auto","background-color":"#f5f6fa"} }
const _hoisted_4 = { class: "performanceOverview" }
const _hoisted_5 = { class: "corePerformance5" }
const _hoisted_6 = {
  class: "flex_cpu_btn",
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_7 = { style: {"display":"flex"} }
const _hoisted_8 = /*#__PURE__*/_createVNode("h5", null, "CPU性能分析", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 确认")
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "参数配置", -1)
const _hoisted_11 = { class: "box_width" }
const _hoisted_12 = { class: "spacName" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { style: {"font-weight":"bold","margin-bottom":"20px"} }, " 阈值设置 ", -1)
const _hoisted_14 = { style: {"display":"flex"} }
const _hoisted_15 = { style: {"display":"flex"} }
const _hoisted_16 = { style: {"display":"flex"} }
const _hoisted_17 = { class: "spacName" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { style: {"font-weight":"bold","margin-bottom":"20px"} }, " 模块设置 ", -1)
const _hoisted_19 = { style: {"display":"flex"} }
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "el-icon-delete-solid" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("新增模块")
const _hoisted_22 = { class: "corePerformance5 spacName" }
const _hoisted_23 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("性能趋势")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_26 = { class: "spacName" }
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("span", null, "线程耗时趋势", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("div", {
  id: "threadTrand",
  style: {"height":"350px"}
}, null, -1)
const _hoisted_30 = {
  key: 0,
  class: "spacName"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("span", null, "so耗时趋势", -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("div", {
  id: "soTrend",
  style: {"height":"350px"}
}, null, -1)
const _hoisted_34 = { class: "spacName" }
const _hoisted_35 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("span", null, "模块耗时趋势", -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode("添加监控")
const _hoisted_38 = /*#__PURE__*/_createVNode("div", {
  id: "moudelTrand",
  style: {"height":"350px"}
}, null, -1)
const _hoisted_39 = { class: "module_djalog" }
const _hoisted_40 = { class: "dialog-content" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("只显示模块")
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { style: {"display":"flex"} }
const _hoisted_48 = /*#__PURE__*/_createTextVNode("添加一行")
const _hoisted_49 = {
  style: {"display":"flex","justify-content":"flex-start"},
  class: "add_input"
}
const _hoisted_50 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_51 = { style: {"text-align":"center","margin-top":"20px"} }
const _hoisted_52 = /*#__PURE__*/_createVNode("span", null, "提交", -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("span", null, "取消修改", -1)
const _hoisted_54 = { class: "corePerformance5 spacName" }
const _hoisted_55 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_56 = /*#__PURE__*/_createTextVNode("CPU占用趋势")
const _hoisted_57 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_58 = /*#__PURE__*/_createVNode("div", {
  style: {"height":"350px"},
  id: "cpu"
}, null, -1)
const _hoisted_59 = { class: "corePerformance5 spacName" }
const _hoisted_60 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_61 = /*#__PURE__*/_createTextVNode("详细数据")
const _hoisted_62 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_63 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("span", null, "CPU Usage", -1)
const _hoisted_65 = { class: "gameTable_cpu" }
const _hoisted_66 = { style: {"font-weight":"bold"} }
const _hoisted_67 = /*#__PURE__*/_createVNode("td", null, "测试场景", -1)
const _hoisted_68 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_69 = /*#__PURE__*/_createVNode("span", null, "线程耗时", -1)
const _hoisted_70 = { class: "spacName gameTable_cpu" }
const _hoisted_71 = { style: {"font-weight":"bold"} }
const _hoisted_72 = /*#__PURE__*/_createVNode("td", null, "测试场景", -1)
const _hoisted_73 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_74 = /*#__PURE__*/_createTextVNode("主要模块耗时")
const _hoisted_75 = /*#__PURE__*/_createTextVNode("添加监控")
const _hoisted_76 = { class: "spacName" }
const _hoisted_77 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_78 = /*#__PURE__*/_createTextVNode("函数耗时")
const _hoisted_79 = { style: {"display":"flex","justify-content":"space-between","margin-top":"20px"} }
const _hoisted_80 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" 离线文件下载 ")
const _hoisted_82 = /*#__PURE__*/_createVNode("div", {
  id: "history_trend",
  style: {"height":"350px","width":"100%"}
}, null, -1)
const _hoisted_83 = { style: {"margin-top":"20px"} }
const _hoisted_84 = { class: "frames-info" }
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" 全局 ")
const _hoisted_86 = { class: "frames-num" }
const _hoisted_87 = /*#__PURE__*/_createTextVNode(" 帧， 时长 ")
const _hoisted_88 = { class: "frames-num" }
const _hoisted_89 = /*#__PURE__*/_createTextVNode(" ms， 平均帧率 ")
const _hoisted_90 = { class: "frames-num" }
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" fps， 平均每帧 ")
const _hoisted_92 = { class: "frames-num" }
const _hoisted_93 = /*#__PURE__*/_createTextVNode(" ms ")
const _hoisted_94 = { class: "frames-info" }
const _hoisted_95 = /*#__PURE__*/_createTextVNode(" 选中 ")
const _hoisted_96 = { class: "frames-num" }
const _hoisted_97 = /*#__PURE__*/_createTextVNode(" 帧， 帧序列 ")
const _hoisted_98 = { class: "frames-num" }
const _hoisted_99 = /*#__PURE__*/_createTextVNode("， 时长 ")
const _hoisted_100 = { class: "frames-num" }
const _hoisted_101 = /*#__PURE__*/_createTextVNode(" ms， 平均帧率 ")
const _hoisted_102 = { class: "frames-num" }
const _hoisted_103 = /*#__PURE__*/_createTextVNode(" fps， 平均每帧 ")
const _hoisted_104 = { class: "frames-num" }
const _hoisted_105 = /*#__PURE__*/_createTextVNode(" ms/frame ")
const _hoisted_106 = {
  key: 0,
  class: "frames-info",
  style: {"margin-top":"10px"}
}
const _hoisted_107 = /*#__PURE__*/_createTextVNode(" 选中时间段 ")
const _hoisted_108 = { class: "frames-num" }
const _hoisted_109 = { style: {"display":"flex","justify-content":"space-between","margin":"20px 0"} }
const _hoisted_110 = {
  class: "pos",
  style: {"display":"flex","text-align":"center","color":"#fff","font-size":"10px"}
}
const _hoisted_111 = /*#__PURE__*/_createVNode("div", {
  id: "analyse",
  style: {"height":"416px","width":"100%"}
}, null, -1)
const _hoisted_112 = { class: "demo-collapse" }
const _hoisted_113 = { class: "corePerformance" }
const _hoisted_114 = { style: {"width":"240px","padding":"10px","display":"flex"} }
const _hoisted_115 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_116 = { class: "ellipsis" }
const _hoisted_117 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_118 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_119 = /*#__PURE__*/_createTextVNode("全部收起")
const _hoisted_120 = { key: 1 }
const _hoisted_121 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_122 = { style: {"width":"50%","margin-right":"20px"} }
const _hoisted_123 = { style: {"width":"5.5%"} }
const _hoisted_124 = { style: {"margin-left":"auto","width":"35%"} }
const _hoisted_125 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_126 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_127 = /*#__PURE__*/_createVNode("div", {
  id: "chart",
  class: "chart-area"
}, null, -1)
const _hoisted_128 = /*#__PURE__*/_createVNode("p", {
  id: "sss",
  class: "json_input",
  contenteditable: "true"
}, null, -1)
const _hoisted_129 = { class: "dialog-footer" }
const _hoisted_130 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_131 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_132 = /*#__PURE__*/_createVNode("div", { id: "testnum" }, [
  /*#__PURE__*/_createVNode("div", {
    id: "cs",
    style: {"width":"210px","color":"#fff"}
  }, ".")
], -1)
const _hoisted_133 = { class: "tree-container" }
const _hoisted_134 = { class: "gallery__box" }
const _hoisted_135 = {
  id: "scro",
  class: "gallery__list"
}
const _hoisted_136 = {
  class: "time_stap",
  style: {"color":"#666"}
}
const _hoisted_137 = { class: "gallery__big_box" }
const _hoisted_138 = {
  ref: "mask",
  class: "gallery__big_wrap"
}
const _hoisted_139 = /*#__PURE__*/_createVNode("i", { class: "el-icon-d-arrow-left" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_drawer = _resolveComponent("el-drawer")
  const _component_h7 = _resolveComponent("h7")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")
  const _component_el_collapse = _resolveComponent("el-collapse")
  const _component_el_tree = _resolveComponent("el-tree")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_el_card, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode(_component_el_form, {
                      style: {"margin-left":"20px"},
                      size: "mini",
                      inline: true
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              filterable: "",
                              modelValue: _ctx.auto_query,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.auto_query = $event)),
                              placeholder: "请选择",
                              multiple: "",
                              "collapse-tags": "",
                              "collapse-tags-tooltip": ""
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.auto_data, (item, k) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: k,
                                    label: item.label,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            (_ctx.report_data.length != 1)
                              ? (_openBlock(), _createBlock(_component_el_select, {
                                  key: 0,
                                  filterable: "",
                                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.subtype_query = '')),
                                  modelValue: _ctx.type_query,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.type_query = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_data, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: item.name,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            (_ctx.report_data.length != 1)
                              ? (_openBlock(), _createBlock(_component_el_select, {
                                  key: _ctx.sub_key,
                                  filterable: "",
                                  modelValue: _ctx.subtype_query,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.subtype_query = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sub_data, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: item.name,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      style: {"margin-left":"20px"},
                      size: "mini",
                      type: "primary",
                      onClick: _ctx.cpu_tree_btn
                    }, {
                      default: _withId(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _createVNode(_component_el_button, {
                    disabled: _ctx.get_is_super,
                    size: "mini",
                    type: "primary",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.open((_ctx.dialogFormVisible1 = true))))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: "暂无管理员权限",
                        placement: "top",
                        disabled: !_ctx.get_is_super
                      }, {
                        default: _withId(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_el_drawer, {
                    title: _ctx.handleFormTitle,
                    modelValue: _ctx.formTask,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.formTask = $event)),
                    direction: "rtl",
                    "destroy-on-close": "",
                    size: "30%"
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_11, [
                        _createVNode(_component_el_card, null, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_12, [
                              _hoisted_13,
                              _createVNode(_component_el_form, {
                                class: "down",
                                size: "mini",
                                model: _ctx.disposeOptions,
                                "label-width": "60px"
                              }, {
                                default: _withId(() => [
                                  _createVNode("div", _hoisted_14, [
                                    _createVNode(_component_el_form_item, { label: "线程" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          "filter-method": 
                                  (value) => _ctx.filterHospital(value, '1')
                                ,
                                          filterable: "",
                                          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.disposeChange('1'))),
                                          modelValue: _ctx.disposeOptions.thread,
                                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.disposeOptions.thread = $event)),
                                          placeholder: "请选择",
                                          multiple: "",
                                          "collapse-tags": "",
                                          "collapse-tags-tooltip": ""
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpu_function_thread_list?.slice(0, 50), (item, k) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: k,
                                                label: item.value,
                                                value: item.label
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["filter-method", "modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, { label: "阈值" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.disposeOptions.thread_threshold,
                                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.disposeOptions.thread_threshold = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("div", _hoisted_15, [
                                    _createVNode(_component_el_form_item, { label: "so" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          "filter-method": 
                                  (value) => _ctx.filterHospital(value, '2')
                                ,
                                          filterable: "",
                                          modelValue: _ctx.disposeOptions.so,
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.disposeOptions.so = $event)),
                                          placeholder: "请选择",
                                          multiple: "",
                                          onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.disposeChange('2'))),
                                          "collapse-tags": "",
                                          "collapse-tags-tooltip": ""
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpu_function_cos_list?.slice(0, 50), (item, k) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: k,
                                                label: item.value,
                                                value: item.label
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["filter-method", "modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, { label: "阈值" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.disposeOptions.so_threshold,
                                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.disposeOptions.so_threshold = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("div", _hoisted_16, [
                                    _createVNode(_component_el_form_item, { label: "模块" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          "filter-method": 
                                  (value) => _ctx.filterHospital(value, '3')
                                ,
                                          filterable: "",
                                          modelValue: _ctx.disposeOptions.module,
                                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.disposeOptions.module = $event)),
                                          placeholder: "请选择",
                                          multiple: "",
                                          "collapse-tags": "",
                                          "collapse-tags-tooltip": ""
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.newResult, (item, k) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: k,
                                                label: item,
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["filter-method", "modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, { label: "阈值" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.disposeOptions.module_threshold,
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.disposeOptions.module_threshold = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              }, 8, ["model"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_card, { style: {"overflow-y":"auto","margin-top":"20px"} }, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_17, [
                              _hoisted_18,
                              _createVNode(_component_el_form, {
                                class: "down",
                                size: "mini",
                                "label-width": "60px"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.module_list, (item, index) => {
                                    return (_openBlock(), _createBlock("div", { key: index }, [
                                      _createVNode("div", _hoisted_19, [
                                        _createVNode(_component_el_form_item, { label: "模块" }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: item.name,
                                              "onUpdate:modelValue": ($event: any) => (item.name = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_el_form_item, { label: "函数" }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_select, {
                                              "filter-method": 
                                    (value) => _ctx.filterHospital(value, '3')
                                  ,
                                              filterable: "",
                                              modelValue: item.value,
                                              "onUpdate:modelValue": ($event: any) => (item.value = $event),
                                              placeholder: "请选择",
                                              multiple: "",
                                              "collapse-tags": "",
                                              "collapse-tags-tooltip": ""
                                            }, {
                                              default: _withId(() => [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpu_function_model_list?.slice(0, 50), (item, k) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: k,
                                                    label: item.value,
                                                    value: item.label
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["filter-method", "modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_el_form_item, { label: "" }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_button, {
                                              onClick: ($event: any) => (_ctx.removeBtn(index)),
                                              size: "mini",
                                              type: "danger"
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_20
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ])
                                    ]))
                                  }), 128)),
                                  _createVNode(_component_el_form_item, null, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addBtn()))
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_21
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["title", "modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_22, [
                _createVNode(_component_h7, {
                  id: "ms_scroll",
                  class: "TitleStyle"
                }, {
                  default: _withId(() => [
                    _hoisted_23,
                    _hoisted_24
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form, {
                  style: {"margin-top":"20px"},
                  model: _ctx.dataOptions,
                  inline: true,
                  size: "mini"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "时间" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.dataOptions.pick,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.dataOptions.pick = $event)),
                          type: "daterange",
                          "range-separator": "To",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          onChange: _cache[17] || (_cache[17] = ($event: any) => (
                      _ctx.dataChange([
                        'date',
                        'device',
                        'scene',
                        'subScene',
                        'thread',
                      ])
                    ))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "测试机型" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.dataOptions.device,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.dataOptions.device = $event)),
                          placeholder: "请选择",
                          filterable: "",
                          onChange: _cache[19] || (_cache[19] = ($event: any) => (
                      _ctx.dataChange(['device', 'scene', 'subScene', 'thread'])
                    ))
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.device_id,
                                label: item.device_name,
                                value: item.device_id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "场景" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.dataOptions.scene,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.dataOptions.scene = $event)),
                          placeholder: "请选择",
                          filterable: "",
                          onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.dataChange(['scene', 'subScene', 'thread'])))
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.scene_id,
                                label: item.chinese,
                                value: item.scene_id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "子场景" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.dataOptions.subScene,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.dataOptions.subScene = $event)),
                          placeholder: "请选择",
                          filterable: "",
                          onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.dataChange([])))
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subScene, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.lable_name,
                                label: item.lable_name,
                                value: item.lable_name
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.affirm()))
                        }, {
                          default: _withId(() => [
                            _hoisted_25
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    false
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "线程"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              "filter-method": (value) => _ctx.filterHospital(value, '4'),
                              filterable: "",
                              onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.dataChange([]))),
                              modelValue: _ctx.dataOptions.thread,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.dataOptions.thread = $event)),
                              placeholder: "请选择",
                              multiple: "",
                              "collapse-tags": "",
                              "collapse-tags-tooltip": ""
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpu_function_thread_list1?.slice(
                        0,
                        50
                      ), (item, k) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: k,
                                    label: item.value,
                                    value: item.label
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["filter-method", "modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createVNode("div", _hoisted_26, [
                  _createVNode(_component_h7, {
                    calsss: "",
                    style: {"display":"flex","align-items":"center","margin-bottom":"20px"}
                  }, {
                    default: _withId(() => [
                      _hoisted_27,
                      _hoisted_28
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createVNode(_component_el_card, null, {
                    default: _withId(() => [
                      _hoisted_29
                    ]),
                    _: 1
                  }, 512), [
                    [_directive_loading, _ctx.threadLoading]
                  ])
                ]),
                (_ctx.soTrendShow)
                  ? (_openBlock(), _createBlock("div", _hoisted_30, [
                      (_ctx.soShow)
                        ? (_openBlock(), _createBlock(_component_h7, {
                            key: 0,
                            calsss: "",
                            style: {"display":"flex","align-items":"center","margin-bottom":"20px"}
                          }, {
                            default: _withId(() => [
                              _hoisted_31,
                              _hoisted_32
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.soShow)
                        ? (_openBlock(), _createBlock(_component_el_form, {
                            key: 1,
                            inline: true,
                            class: "spacForm",
                            size: "mini",
                            model: _ctx.disposeOptions
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "线程选择" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.trendOptions.thread,
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.trendOptions.thread = $event)),
                                    placeholder: "请选择",
                                    filterable: "",
                                    onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.trendChange('thread')))
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.threadTrendOptions, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item,
                                          label: item,
                                          value: item
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["model"]))
                        : _createCommentVNode("", true),
                      (_ctx.soShow)
                        ? _withDirectives((_openBlock(), _createBlock(_component_el_card, { key: 2 }, {
                            default: _withId(() => [
                              _hoisted_33
                            ]),
                            _: 1
                          }, 512)), [
                            [_directive_loading, _ctx.soTrendLoading]
                          ])
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_34, [
                  _createVNode(_component_h7, {
                    calsss: "",
                    style: {"display":"flex","align-items":"center","margin-bottom":"20px"}
                  }, {
                    default: _withId(() => [
                      _hoisted_35,
                      _hoisted_36
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form, {
                    inline: true,
                    class: "spacForm",
                    size: "mini",
                    model: _ctx.disposeOptions
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "线程选择" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.trendOptions.thread1,
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.trendOptions.thread1 = $event)),
                            placeholder: "请选择",
                            filterable: "",
                            onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.trendChange('thread1')))
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.threadTrendOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "so选择" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.trendOptions.so,
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.trendOptions.so = $event)),
                            placeholder: "请选择",
                            filterable: "",
                            onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.trendChange('so')))
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.soTrendOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: 
                          item?.indexOf('/') != -1
                            ? item?.split('/')[item?.split('/').length - 1]
                            : item
                        ,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            size: "mini",
                            type: "primary",
                            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.tableAddShow = true))
                          }, {
                            default: _withId(() => [
                              _hoisted_37
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"]),
                  _withDirectives(_createVNode(_component_el_card, null, {
                    default: _withId(() => [
                      _hoisted_38
                    ]),
                    _: 1
                  }, 512), [
                    [_directive_loading, _ctx.moduleLoading]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_39, [
                _createVNode(_component_el_dialog, {
                  modelValue: _ctx.tableAddShow,
                  "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (_ctx.tableAddShow = $event)),
                  width: "80%",
                  class: "custom-dialog",
                  height: "auto"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_40, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.conFig.is_show_function_check,
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.conFig.is_show_function_check = $event))
                      }, {
                        default: _withId(() => [
                          _hoisted_41
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_table, {
                        border: "",
                        size: "mini",
                        "header-cell-style": {
                      background: '#5D99D5',
                      color: '#fff',
                    },
                        data: _ctx.conFig.module_list
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, { label: "线程" }, {
                            default: _withId((scope) => [
                              (!scope.row.edit)
                                ? (_openBlock(), _createBlock("span", _hoisted_42, _toDisplayString(scope.row.thread), 1))
                                : (_openBlock(), _createBlock(_component_el_input, {
                                    key: 1,
                                    modelValue: scope.row.thread,
                                    "onUpdate:modelValue": ($event: any) => (scope.row.thread = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            ]),
                            _: 1
                          }),
                          (_ctx.localProject != 7)
                            ? (_openBlock(), _createBlock(_component_el_table_column, {
                                key: 0,
                                label: "so"
                              }, {
                                default: _withId((scope) => [
                                  (!scope.row.edit)
                                    ? (_openBlock(), _createBlock("span", _hoisted_43, _toDisplayString(scope.row.so), 1))
                                    : (_openBlock(), _createBlock(_component_el_input, {
                                        key: 1,
                                        modelValue: scope.row.so,
                                        "onUpdate:modelValue": ($event: any) => (scope.row.so = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_table_column, { label: "模块/函数名" }, {
                            default: _withId((scope) => [
                              (!scope.row.edit)
                                ? (_openBlock(), _createBlock("span", _hoisted_44, _toDisplayString(scope.row.module), 1))
                                : (_openBlock(), _createBlock(_component_el_input, {
                                    key: 1,
                                    modelValue: scope.row.module,
                                    "onUpdate:modelValue": ($event: any) => (scope.row.module = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "是否函数",
                            width: "80"
                          }, {
                            default: _withId((scope) => [
                              _createVNode(_component_el_checkbox, {
                                disabled: !scope.row.edit,
                                modelValue: scope.row.func_check,
                                "onUpdate:modelValue": ($event: any) => (scope.row.func_check = $event)
                              }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, { label: "父模块" }, {
                            default: _withId((scope) => [
                              (!scope.row.edit)
                                ? (_openBlock(), _createBlock("span", _hoisted_45, _toDisplayString(scope.row.parent), 1))
                                : (_openBlock(), _createBlock(_component_el_input, {
                                    key: 1,
                                    modelValue: scope.row.parent,
                                    "onUpdate:modelValue": ($event: any) => (scope.row.parent = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "函数列表",
                            width: "400"
                          }, {
                            default: _withId((scope) => [
                              (!scope.row.edit)
                                ? (_openBlock(), _createBlock("div", _hoisted_46, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(scope.row.functions, (item) => {
                                      return (_openBlock(), _createBlock("div", { key: item }, _toDisplayString(item), 1))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createBlock(_component_el_input, {
                                    key: 1,
                                    rows: "10",
                                    type: "textarea",
                                    modelValue: scope.row.functions_string,
                                    "onUpdate:modelValue": ($event: any) => (scope.row.functions_string = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "趋势图",
                            width: "80"
                          }, {
                            default: _withId((scope) => [
                              _createVNode(_component_el_checkbox, {
                                disabled: !scope.row.edit,
                                modelValue: scope.row.trend_check,
                                "onUpdate:modelValue": ($event: any) => (scope.row.trend_check = $event)
                              }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "表格",
                            width: "80"
                          }, {
                            default: _withId((scope) => [
                              _createVNode(_component_el_checkbox, {
                                disabled: !scope.row.edit,
                                modelValue: scope.row.show_check,
                                "onUpdate:modelValue": ($event: any) => (scope.row.show_check = $event)
                              }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, { label: "操作" }, {
                            default: _withId((scope) => [
                              _createVNode("div", _hoisted_47, [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  size: "mini",
                                  onClick: ($event: any) => (_ctx.edit(scope.row))
                                }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(scope.row.edit ? "确认" : "修改"), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createVNode(_component_el_button, {
                                  type: "danger",
                                  size: "mini",
                                  onClick: ($event: any) => (_ctx.clear(scope.row, scope.$index))
                                }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(scope.row.edit ? "取消" : "删除"), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]),
                      (!_ctx.addShow)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            size: "mini",
                            style: {"margin-top":"10px"},
                            type: "primary",
                            onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.addRow()))
                          }, {
                            default: _withId(() => [
                              _hoisted_48
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.addShow)
                        ? (_openBlock(), _createBlock(_component_el_form, {
                            key: 1,
                            style: {"margin":"10px 0"},
                            size: "mini",
                            "label-position": "top"
                          }, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_49, [
                                _createVNode(_component_el_form_item, {
                                  label: "线程",
                                  style: {"margin-right":"25px"}
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[36] || (_cache[36] = ($event: any) => (_ctx.add_row_data.so = '')),
                                      modelValue: _ctx.add_row_data.thread,
                                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.add_row_data.thread = $event)),
                                      id: "old_version",
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.thread_add, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: item,
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "so",
                                  style: {"margin-right":"35px"}
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.add_row_data.so,
                                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.add_row_data.so = $event)),
                                      id: "old_version",
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.so_list[_ctx.add_row_data.thread], (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: item,
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "模块/函数名",
                                  style: {"margin-right":"45px"}
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.add_row_data.moudel,
                                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_ctx.add_row_data.moudel = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "是否函数",
                                  width: "50",
                                  style: {"margin-right":"35px"}
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_checkbox, {
                                      modelValue: _ctx.add_row_data.func_check,
                                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.add_row_data.func_check = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "父模块",
                                  style: {"margin-right":"35px"}
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.add_row_data.parent,
                                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.add_row_data.parent = $event)),
                                      id: "old_version",
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.parentList, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: item,
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "函数名",
                                  style: {"margin-right":"35px"}
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      type: "textarea",
                                      rows: "1",
                                      modelValue: _ctx.add_row_data.functions_string,
                                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.add_row_data.functions_string = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "趋势图",
                                  style: {"margin-right":"35px"}
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_checkbox, {
                                      modelValue: _ctx.add_row_data.trend_check,
                                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.add_row_data.trend_check = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "表格",
                                  style: {"margin-right":"35px"}
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_checkbox, {
                                      modelValue: _ctx.add_row_data.show_check,
                                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_ctx.add_row_data.show_check = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "按钮" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_button, {
                                      size: "mini",
                                      type: "primary",
                                      onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.addList()))
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_50
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_51, [
                        _createVNode(_component_el_popconfirm, {
                          title: "确认提交？",
                          onConfirm: _cache[46] || (_cache[46] = ($event: any) => (_ctx.submit_edit())),
                          placement: "top"
                        }, {
                          reference: _withId(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              size: "mini"
                            }, {
                              default: _withId(() => [
                                _hoisted_52
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_popconfirm, {
                          title: "确认是否放弃本次修改？",
                          onConfirm: _cache[47] || (_cache[47] = ($event: any) => (_ctx.submit_cancellation())),
                          placement: "top"
                        }, {
                          reference: _withId(() => [
                            _createVNode(_component_el_button, {
                              type: "info",
                              size: "mini"
                            }, {
                              default: _withId(() => [
                                _hoisted_53
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode("div", _hoisted_54, [
                _createVNode(_component_h7, null, {
                  default: _withId(() => [
                    _hoisted_55,
                    _hoisted_56
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form, {
                  style: {"margin-top":"20px"},
                  class: "spacForm",
                  model: _ctx.dataOptions,
                  inline: true,
                  size: "mini"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "时间" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.trendData.pick,
                          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (_ctx.trendData.pick = $event)),
                          type: "daterange",
                          "range-separator": "To",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "测试机型" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.trendData.device,
                          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (_ctx.trendData.device = $event)),
                          placeholder: "请选择",
                          filterable: ""
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.device_id,
                                label: item.device_name,
                                value: item.device_id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "场景" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.trendData.scene,
                          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.trendData.scene = $event)),
                          placeholder: "请选择",
                          filterable: ""
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.scene_id,
                                label: item.chinese,
                                value: item.scene_id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.affirm1()))
                        }, {
                          default: _withId(() => [
                            _hoisted_57
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    false
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "线程"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              "filter-method": (value) => _ctx.filterHospital(value, '4'),
                              filterable: "",
                              onChange: _cache[53] || (_cache[53] = ($event: any) => (_ctx.dataChange([]))),
                              modelValue: _ctx.dataOptions.thread,
                              "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => (_ctx.dataOptions.thread = $event)),
                              placeholder: "请选择",
                              multiple: "",
                              "collapse-tags": "",
                              "collapse-tags-tooltip": ""
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpu_function_thread_list1?.slice(
                        0,
                        50
                      ), (item, k) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: k,
                                    label: item.value,
                                    value: item.label
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["filter-method", "modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["model"]),
                _withDirectives(_createVNode(_component_el_card, null, {
                  default: _withId(() => [
                    _hoisted_58
                  ]),
                  _: 1
                }, 512), [
                  [_directive_loading, _ctx.cpuTrendLoading]
                ])
              ]),
              _createVNode("div", _hoisted_59, [
                _createVNode(_component_h7, {
                  id: "thread_scroll",
                  class: "TitleStyle"
                }, {
                  default: _withId(() => [
                    _hoisted_60,
                    _hoisted_61
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form, {
                  style: {"margin-top":"20px"},
                  model: _ctx.dataConsumeOptions,
                  inline: true,
                  size: "mini"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      class: "version_input",
                      label: "当前版本"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.dataConsumeOptions.version,
                          "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => (_ctx.dataConsumeOptions.version = $event)),
                          placeholder: "请选择",
                          onChange: _cache[56] || (_cache[56] = ($event: any) => (
                      _ctx.versionChange(
                        ['version', 'device', 'scene', 'idLabel', ''],
                        true
                      )
                    )),
                          filterable: ""
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.versionsOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item,
                                label: item.chinese,
                                value: item.chinese
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "测试机型" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          onChange: _cache[57] || (_cache[57] = ($event: any) => (
                      _ctx.versionChange(['device', 'scene', 'idLabel'], true)
                    )),
                          modelValue: _ctx.dataConsumeOptions.device,
                          "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => (_ctx.dataConsumeOptions.device = $event)),
                          placeholder: "请选择",
                          filterable: ""
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options_old, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.device_id,
                                label: item.device_name,
                                value: item.device_id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "测试场景" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          onChange: _cache[59] || (_cache[59] = ($event: any) => (
                      _ctx.versionChange(['device', 'scene', 'idLabel'], true)
                    )),
                          modelValue: _ctx.dataConsumeOptions.scene,
                          "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => (_ctx.dataConsumeOptions.scene = $event)),
                          placeholder: "请选择",
                          filterable: ""
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options_old, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.scene_id,
                                label: item.chinese,
                                value: item.scene_id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    (_ctx.threadShow)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "线程"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              onChange: _cache[61] || (_cache[61] = ($event: any) => (_ctx.versionChange([], false))),
                              modelValue: _ctx.dataConsumeOptions.thread,
                              "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => (_ctx.dataConsumeOptions.thread = $event)),
                              placeholder: "请选择",
                              filterable: ""
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.threadOldOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item,
                                    value: item
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_form_item, { label: "" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.affirmBtn()))
                        }, {
                          default: _withId(() => [
                            _hoisted_62
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createVNode(_component_el_form, {
                  model: _ctx.dataConsumeOptions,
                  inline: true,
                  size: "mini"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      class: "version_input",
                      label: "对比版本"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          onChange: _cache[64] || (_cache[64] = ($event: any) => (_ctx.versionChange([], true))),
                          modelValue: _ctx.dataConsumeOptions.old_verson,
                          "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => (_ctx.dataConsumeOptions.old_verson = $event)),
                          placeholder: "请选择",
                          filterable: ""
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.versionsOldOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item,
                                label: item.chinese,
                                value: item.chinese
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createVNode(_component_h7, {
                  id: "cpu_usage",
                  style: {"display":"flex","align-items":"center","margin-bottom":"20px"}
                }, {
                  default: _withId(() => [
                    _hoisted_63,
                    _hoisted_64
                  ]),
                  _: 1
                }),
                _createVNode("table", _hoisted_65, [
                  _createVNode("thead", _hoisted_66, [
                    _createVNode("tr", null, [
                      _hoisted_67,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.params, (item) => {
                        return (_openBlock(), _createBlock("td", { key: item }, _toDisplayString(item.name), 1))
                      }), 128))
                    ])
                  ]),
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpu_usage_data, (v) => {
                      return (_openBlock(), _createBlock("tr", { key: v }, [
                        _createVNode("td", null, _toDisplayString(v.label), 1),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.params, (item) => {
                          return (_openBlock(), _createBlock("td", { key: item }, [
                            _createVNode("span", {
                              style: 
                          'color:' +
                          _ctx.com_num_color5(v.new[item.value], 'cpu', item.name)
                        
                            }, _toDisplayString(v.new[item.value]), 5),
                            _createVNode("span", {
                              style: 
                          'color:' +
                          _ctx.com_num_color3(
                            v.new[item.value],
                            v.old[item.value],
                            'cpu',
                            item.name
                          )
                        
                            }, "(" + _toDisplayString(_ctx.getNum(v.new[item.value], v.old[item.value])) + ")", 5)
                          ]))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ]),
                _createVNode(_component_h7, {
                  id: "thread_scroll",
                  style: {"display":"flex","align-items":"center","margin":"20px 0"}
                }, {
                  default: _withId(() => [
                    _hoisted_68,
                    _hoisted_69
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode("table", _hoisted_70, [
                  _createVNode("thead", _hoisted_71, [
                    _createVNode("tr", null, [
                      _hoisted_72,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.overList, (item) => {
                        return (_openBlock(), _createBlock("td", { key: item }, _toDisplayString(_ctx.getChinese(item)), 1))
                      }), 128))
                    ])
                  ]),
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.overviewData, (item, index) => {
                      return (_openBlock(), _createBlock("tr", { key: index }, [
                        _createVNode("td", null, _toDisplayString(item.label_name), 1),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.overList, (i, k) => {
                          return (_openBlock(), _createBlock("td", { key: k }, [
                            _createTextVNode(_toDisplayString(item.new[i]), 1),
                            _createVNode("span", {
                              style: 
                          'color:' +
                          _ctx.com_num_color1(item.new[i], item.old[i], 'thread', i)
                        
                            }, "(" + _toDisplayString(_ctx.getNum(item.new[i], item.old[i])) + ")", 5)
                          ]))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ], 512), [
                  [_directive_loading, _ctx.functiontableLoading]
                ]),
                _createVNode("div", null, [
                  _createVNode(_component_h7, {
                    id: "moudle_scroll",
                    class: "TitleStyle"
                  }, {
                    default: _withId(() => [
                      _hoisted_73,
                      _hoisted_74
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form, {
                    style: {"margin-top":"20px"},
                    model: _ctx.dataConsumeOptions,
                    inline: true,
                    size: "mini"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "子场景" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.dataConsumeOptions.subScene,
                            "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => (_ctx.dataConsumeOptions.subScene = $event)),
                            placeholder: "请选择",
                            filterable: "",
                            onChange: _cache[67] || (_cache[67] = ($event: any) => (_ctx.versionChange(['subScene'], false)))
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subSceneOld, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.lable_name,
                                  label: item.lable_name,
                                  value: item.lable_name
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            size: "mini",
                            type: "primary",
                            onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.tableAddShow = true))
                          }, {
                            default: _withId(() => [
                              _hoisted_75
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"]),
                  _withDirectives(_createVNode(_component_el_table, {
                    id: "moudle_scroll",
                    class: "spacName",
                    size: "mini",
                    border: "",
                    "header-cell-style": {
                    background: '#5D99D5',
                    color: '#fff',
                  },
                    "cell-style": _ctx.cellStyle,
                    data: _ctx.function_list_data
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_table_column, {
                        width: "800",
                        "show-overflow-tooltip": true,
                        label: "线程模块"
                      }, {
                        default: _withId((scope) => [
                          _createVNode("span", {
                            style: 'margin-left:' + _ctx.depth(scope.row.depth) + 'px'
                          }, _toDisplayString(scope.row.name), 5)
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.function_label_list, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_table_column, {
                          align: "center",
                          label: item,
                          key: index
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, { label: "耗时" }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(typeof scope.row.list[index].event_count == "number"
                            ? scope.row.list[index].event_count.toFixed(2)
                            : "--"), 1),
                                _createVNode("span", {
                                  style: 
                            'color:' +
                            _ctx.com_num_color(
                              scope.row.list[index].event_count,
                              scope.row.list[index].old_event_count,
                              scope.row.type,
                              true
                            )
                          
                                }, "(" + _toDisplayString(_ctx.getNum(
                              scope.row.list[index].event_count,
                              scope.row.list[index].old_event_count
                            )) + ")", 5)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_table_column, { label: "比例" }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(typeof scope.row.list[index].rate == "number"
                            ? scope.row.list[index].rate.toFixed(2) + "%"
                            : "--"), 1),
                                _createVNode("span", {
                                  style: 
                            'color:' +
                            _ctx.com_num_color(
                              scope.row.list[index].rate,
                              scope.row.list[index].old_rate,
                              scope.row.type,
                              false
                            )
                          
                                }, "(" + _toDisplayString(_ctx.getNum(
                              scope.row.list[index].rate,
                              scope.row.list[index].old_rate
                            ) != "--"
                              ? _ctx.getNum(
                                  scope.row.list[index].rate,
                                  scope.row.list[index].old_rate
                                )
                              : "--") + ")", 5)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["cell-style", "data"]), [
                    [_directive_loading, _ctx.functionNameLoading]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_76, [
                _createVNode(_component_h7, {
                  id: "func_scroll",
                  class: "TitleStyle"
                }, {
                  default: _withId(() => [
                    _hoisted_77,
                    _hoisted_78
                  ]),
                  _: 1
                }),
                _createVNode("div", _hoisted_79, [
                  _createVNode(_component_el_form, {
                    model: _ctx.dataConsumeOptions,
                    inline: true,
                    size: "mini"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, {
                        class: "version_input",
                        label: "当前版本"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.trendDataOptions.version,
                            "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => (_ctx.trendDataOptions.version = $event)),
                            placeholder: "请选择",
                            onChange: _cache[70] || (_cache[70] = ($event: any) => (_ctx.versionChange1(true))),
                            filterable: ""
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.versionsOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item.chinese,
                                  value: item.chinese
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "测试机型" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[71] || (_cache[71] = ($event: any) => (_ctx.versionChange1(false))),
                            modelValue: _ctx.trendDataOptions.device,
                            "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => (_ctx.trendDataOptions.device = $event)),
                            placeholder: "请选择",
                            filterable: ""
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.lastDevice, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.device_id,
                                  label: item.device_name,
                                  value: item.device_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "测试场景" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[73] || (_cache[73] = ($event: any) => (_ctx.versionChange1(false))),
                            modelValue: _ctx.trendDataOptions.scene,
                            "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => (_ctx.trendDataOptions.scene = $event)),
                            placeholder: "请选择",
                            filterable: ""
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.lastScene, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.scene_id,
                                  label: item.chinese,
                                  value: item.scene_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _cache[75] || (_cache[75] = ($event: any) => (_ctx.affirmBtn2()))
                          }, {
                            default: _withId(() => [
                              _hoisted_80
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"]),
                  _createVNode(_component_el_form, {
                    onsubmit: "return false",
                    inline: true
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "mini"
                      }, {
                        default: _withId(() => [
                          _createVNode("a", {
                            style: {"color":"#fff","text-decoration":"none"},
                            onClick: _cache[76] || (_cache[76] = ($event: any) => (_ctx.runMax(_ctx.cpu_by_frame.id_test)))
                          }, "基础性能数据")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_popconfirm, {
                        title: "因数据量较大，离线文件可能存在加载较慢或失败的现象，请多尝试几次，如问题一直存在可反馈至平台.\n  确认要下载这个文件吗？",
                        onConfirm: _cache[77] || (_cache[77] = ($event: any) => (_ctx.downloadFile(_ctx.flame_url?.url))),
                        placement: "top"
                      }, {
                        reference: _withId(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "mini"
                          }, {
                            default: _withId(() => [
                              _hoisted_81
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_el_dialog, {
                  modelValue: _ctx.historyShow,
                  "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => (_ctx.historyShow = $event)),
                  width: "50%"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_card, null, {
                      default: _withId(() => [
                        _hoisted_82
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode("div", _hoisted_83, [
                  _createVNode("p", _hoisted_84, [
                    _hoisted_85,
                    _createVNode("span", _hoisted_86, _toDisplayString(_ctx.framesInfo_all.framesCount * _ctx.frame_merge_size), 1),
                    _hoisted_87,
                    _createVNode("span", _hoisted_88, _toDisplayString((_ctx.framesInfo_all.sumTime * _ctx.frame_merge_size).toFixed(2)), 1),
                    _hoisted_89,
                    _createVNode("span", _hoisted_90, _toDisplayString(_ctx.framesInfo_all.FPS), 1),
                    _hoisted_91,
                    _createVNode("span", _hoisted_92, _toDisplayString(_ctx.framesInfo_all.frameTime), 1),
                    _hoisted_93
                  ]),
                  _createVNode("p", _hoisted_94, [
                    _hoisted_95,
                    _createVNode("span", _hoisted_96, _toDisplayString(_ctx.framesInfo.framesCount * _ctx.frame_merge_size), 1),
                    _hoisted_97,
                    _createVNode("span", _hoisted_98, _toDisplayString(_ctx.framesInfo.start * _ctx.frame_merge_size) + "-" + _toDisplayString((_ctx.framesInfo.end + 1) * _ctx.frame_merge_size), 1),
                    _hoisted_99,
                    _createVNode("span", _hoisted_100, _toDisplayString((_ctx.framesInfo.sumTime * _ctx.frame_merge_size).toFixed(2)), 1),
                    _hoisted_101,
                    _createVNode("span", _hoisted_102, _toDisplayString(_ctx.framesInfo.FPS), 1),
                    _hoisted_103,
                    _createVNode("span", _hoisted_104, _toDisplayString(_ctx.framesInfo.frameTime), 1),
                    _hoisted_105
                  ]),
                  (_ctx.selectShow)
                    ? (_openBlock(), _createBlock("p", _hoisted_106, [
                        _hoisted_107,
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList, (item, index) => {
                          return (_openBlock(), _createBlock("span", { key: index }, [
                            _createTextVNode(_toDisplayString(item.name) + " ", 1),
                            _createVNode("span", _hoisted_108, _toDisplayString(item.sum.toFixed(2)), 1),
                            _createVNode("span", null, _toDisplayString(index == _ctx.selectList?.length - 1 ? "" : "，"), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_109, [
                  _withDirectives(_createVNode(_component_el_card, { style: {"position":"relative","width":"100%"} }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_110, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                          return (_openBlock(), _createBlock("div", {
                            key: index,
                            style: {
                        background: item.color,
                        width: item.width,
                      }
                          }, _toDisplayString(_ctx.getName(item.label, index)), 5))
                        }), 128))
                      ]),
                      _hoisted_111
                    ]),
                    _: 1
                  }, 512), [
                    [_directive_loading, _ctx.functionNameTrend]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_112, [
                _createVNode(_component_el_collapse, {
                  modelValue: _ctx.activeNames,
                  "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => (_ctx.activeNames = $event)),
                  onChange: _ctx.handleChange
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_collapse_item, {
                      title: "函数表",
                      name: "1"
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_113, [
                          _withDirectives(_createVNode(_component_el_table, {
                            border: "",
                            class: "my-table",
                            data: _ctx.tableList_new,
                            key: _ctx.itemKey,
                            onSortChange: _ctx.sort_change
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, { label: "搜索" }, {
                                header: _withId(() => [
                                  _createVNode("div", _hoisted_114, [
                                    _createVNode(_component_el_input, {
                                      onKeyup: _withKeys(_ctx.serchChange_enter, ["enter"]),
                                      style: {"margin-right":"20px"},
                                      modelValue: _ctx.serch,
                                      "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => (_ctx.serch = $event)),
                                      size: "mini",
                                      width: "200",
                                      placeholder: "输入名称关键字搜索"
                                    }, null, 8, ["onKeyup", "modelValue"]),
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      size: "mini",
                                      onClick: _ctx.serchChange
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_115
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ])
                                ]),
                                default: _withId(() => [
                                  _createVNode(_component_el_table_column, {
                                    "show-overflow-tooltip": "false",
                                    prop: "name",
                                    label: "函数"
                                  }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", _hoisted_116, _toDisplayString(scope.row.name), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "time",
                                    sortable: "custom",
                                    width: "150",
                                    label: "耗时(ms)"
                                  }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", null, _toDisplayString(scope.row.time), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "rate",
                                    sortable: "custom",
                                    width: "80",
                                    label: "占比"
                                  }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", null, _toDisplayString(scope.row.rate) + "%", 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "average_value",
                                    sortable: "custom",
                                    width: "220",
                                    label: "平均耗时(ms)"
                                  }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", null, _toDisplayString(scope.row.average_value), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "difference",
                                    sortable: "custom",
                                    width: "200",
                                    label: "差异(ms)"
                                  }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", null, _toDisplayString(scope.row.difference), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "difference",
                                    width: "150",
                                    label: "迭代趋势"
                                  }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", {
                                        onClick: ($event: any) => (_ctx.view_trend(scope.row.name)),
                                        style: {"cursor":"pointer","color":"#61c3e4"}
                                      }, "查看", 8, ["onClick"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    width: "100",
                                    label: "查看曲线"
                                  }, {
                                    default: _withId((scope) => [
                                      _createVNode(_component_el_checkbox, {
                                        disabled: scope.row.id === 9999999,
                                        modelValue: scope.row.check,
                                        "onUpdate:modelValue": ($event: any) => (scope.row.check = $event),
                                        onChange: ($event: any) => (
                                _ctx.checkChange(
                                  scope.row.check,
                                  scope.row.id,
                                  scope.row.name
                                )
                              )
                                      }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data", "onSortChange"]), [
                            [_directive_loading, _ctx.functionStack1]
                          ]),
                          _createVNode(_component_el_pagination, {
                            class: "page_count",
                            style: {"text-align":"right","margin-top":"10px"},
                            currentPage: _ctx.currentPage,
                            "onUpdate:currentPage": _cache[80] || (_cache[80] = ($event: any) => (_ctx.currentPage = $event)),
                            Page: "currentPage",
                            "page-size": "10",
                            total: _ctx.total,
                            layout: "total, prev, pager, next, jumper",
                            onCurrentChange: _ctx.handleCurrentChange
                          }, null, 8, ["currentPage", "total", "onCurrentChange"])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_collapse_item, {
                      title: "树形图",
                      name: "2"
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_117, [
                          _createVNode(_component_el_form, {
                            inline: true,
                            size: "mini"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "mini",
                                    onClick: _ctx.submit
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_118
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    onKeyup: _withKeys(_ctx.serchChange_enter, ["enter"]),
                                    modelValue: _ctx.inputValue,
                                    "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => (_ctx.inputValue = $event))
                                  }, null, 8, ["onKeyup", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _withDirectives(_createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    onKeyup: _withKeys(_ctx.serchChange_enter, ["enter"]),
                                    modelValue: _ctx.inputValue,
                                    "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => (_ctx.inputValue = $event))
                                  }, null, 8, ["onKeyup", "modelValue"])
                                ]),
                                _: 1
                              }, 512), [
                                [_vShow, false]
                              ]),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _cache[83] || (_cache[83] = ($event: any) => (_ctx.close1(_ctx.stackData, _ctx.state)))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_119
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _withDirectives(_createVNode(_component_el_table, {
                          id: "func",
                          "row-style": _ctx.tableRowClassName,
                          class: "customer-table",
                          onRowClick: _ctx.handleRowClick,
                          "default-expand-all": _ctx.isExpand,
                          data: _ctx.stackData_all,
                          size: "small",
                          "header-cell-style": {
                      background: '#1B1B1B',
                      color: '#B5B5B5',
                      border: '0',
                      padding: '1px,0',
                      height: '10px',
                    },
                          ref: "table",
                          style: {"width":"100%","margin-bottom":"20px"},
                          "row-key": "id"
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.details_list, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_table_column, {
                                "show-overflow-tooltip": true,
                                key: index,
                                index: index,
                                label: item.label,
                                width: item.label == 'func_name' ? '800' : '',
                                title: item.prop
                              }, {
                                default: _withId((scope) => [
                                  (item.prop != 'rate')
                                    ? (_openBlock(), _createBlock("span", {
                                        key: 0,
                                        id: scope.row.id
                                      }, _toDisplayString(scope.row[item.prop]), 9, ["id"]))
                                    : (_openBlock(), _createBlock("span", _hoisted_120, _toDisplayString(scope.row[item.prop] + "%"), 1))
                                ]),
                                _: 2
                              }, 1032, ["index", "label", "width", "title"]))
                            }), 128)),
                            _createVNode(_component_el_table_column, { label: "平均耗时(ms)" }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(_ctx.func_list[scope.row.id]?.value
                            ? _ctx.func_list[scope.row.id]?.value
                            : ""), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, { label: "曲线" }, {
                              default: _withId((scope) => [
                                _createVNode("span", {
                                  style: {"cursor":"pointer","font-size":"21px"},
                                  onClick: ($event: any) => (_ctx.look(scope.row))
                                }, _toDisplayString(scope.row.check ? "-" : "+"), 9, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["row-style", "onRowClick", "default-expand-all", "data"]), [
                          [_directive_loading, _ctx.functionStack]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_collapse_item, {
                      title: "火焰图",
                      name: "3"
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_121, [
                          _createVNode("div", _hoisted_122, [
                            _createVNode(_component_el_input, {
                              size: "mini",
                              modelValue: _ctx.func_name,
                              "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => (_ctx.func_name = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createVNode("div", _hoisted_123, [
                            _createVNode(_component_el_input, {
                              size: "mini",
                              modelValue: _ctx.func_rate,
                              "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => (_ctx.func_rate = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createVNode("div", _hoisted_124, [
                            _createVNode("div", _hoisted_125, [
                              _createVNode(_component_el_input, {
                                style: {"margin-right":"20px"},
                                modelValue: _ctx.flame_serch,
                                "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => (_ctx.flame_serch = $event)),
                                placeholder: "搜索",
                                "prefix-icon": "el-icon-search",
                                size: "mini"
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_el_button, {
                                type: "primary",
                                size: "mini",
                                onClick: _cache[87] || (_cache[87] = ($event: any) => (_ctx.recordSearch()))
                              }, {
                                default: _withId(() => [
                                  _hoisted_126
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _withDirectives(_createVNode("div", null, [
                          _hoisted_127
                        ], 512), [
                          [_directive_loading, _ctx.functionStack1]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _createVNode(_component_el_dialog, {
                width: "50%",
                modelValue: _ctx.dialogFormVisible1,
                "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => (_ctx.dialogFormVisible1 = $event)),
                title: "参数配置"
              }, {
                footer: _withId(() => [
                  _createVNode("span", _hoisted_129, [
                    _createVNode(_component_el_button, {
                      onClick: _cache[89] || (_cache[89] = ($event: any) => (_ctx.dialogFormVisible1 = false))
                    }, {
                      default: _withId(() => [
                        _hoisted_130
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[90] || (_cache[90] = ($event: any) => (_ctx.closeBtn()))
                    }, {
                      default: _withId(() => [
                        _hoisted_131
                      ]),
                      _: 1
                    })
                  ])
                ]),
                default: _withId(() => [
                  _hoisted_128
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", null, [
        _hoisted_132,
        _createVNode("div", _hoisted_133, [
          _createVNode(_component_el_tree, {
            "node-class": _ctx.nodeClass,
            class: "floating-tree",
            data: _ctx.treeData,
            props: _ctx.defaultProps,
            accordion: "",
            "default-expand-all": "",
            onNodeClick: _ctx.handleNodeClick
          }, null, 8, ["node-class", "data", "props", "onNodeClick"])
        ]),
        _createVNode("div", {
          class: "down_nav_list",
          style: { width: _ctx.innerwidth, transition: _ctx.trans_time }
        }, [
          _withDirectives(_createVNode("div", _hoisted_134, [
            _createVNode("ul", _hoisted_135, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pictureArr, (item, index) => {
                return (_openBlock(), _createBlock("li", {
                  id: item.time + item.img,
                  class: { select: _ctx.displaylist == index },
                  key: index
                }, [
                  _createVNode("img", {
                    onClick: ($event: any) => (_ctx.btn(index)),
                    src: item.img,
                    style: {"width":"210px"}
                  }, null, 8, ["onClick", "src"]),
                  _createVNode("p", _hoisted_136, _toDisplayString(item.time), 1)
                ], 10, ["id"]))
              }), 128))
            ])
          ], 512), [
            [_vShow, _ctx.rightBtn]
          ]),
          (_ctx.showMask)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                onClick: _cache[94] || (_cache[94] = ($event: any) => (_ctx.maskBtn($event))),
                class: "gallery__big"
              }, [
                _createVNode("div", _hoisted_137, [
                  _createVNode("div", _hoisted_138, [
                    _createVNode("i", {
                      onClick: _cache[92] || (_cache[92] = ($event: any) => (_ctx.leftBtn(_ctx.maskImg?.img))),
                      class: "el-icon-arrow-left",
                      style: {"display":"inline-block","height":"100%","font-size":"54px","cursor":"pointer"}
                    }),
                    _createVNode("img", {
                      src: _ctx.maskImg?.img
                    }, null, 8, ["src"]),
                    _createVNode("i", {
                      onClick: _cache[93] || (_cache[93] = ($event: any) => (_ctx.rightBtn1(_ctx.maskImg?.img))),
                      class: "el-icon-arrow-right",
                      style: {"display":"inline-block","height":"100%","font-size":"54px","cursor":"pointer"}
                    })
                  ], 512)
                ])
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode("button", {
            disabled: _ctx.closePictureBtn,
            onClick: _cache[95] || (_cache[95] = 
//@ts-ignore
(...args) => (_ctx.pictureSwitch && _ctx.pictureSwitch(...args))),
            class: _ctx.closePictureBtn === false ? 'gallery_btn' : 'gallery_btn1'
          }, [
            _hoisted_139
          ], 10, ["disabled"]), [
            [_vShow, _ctx.rightBtn]
          ])
        ], 4)
      ])
    ])
  ]))
})